<template>
    <div>
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>

        <b-card 
            id="license-count-table-card"
            class="rounded-lg animate__animated animate__fadeIn animate__fast"
            no-body
        >

            <b-table
                v-if="initialDataLoaded"
                :items="countsList"
                :fields="fields"
                class="no-top-border td-align-middle mb-0"
            >
                <template #cell(roles)="data">
                    <div v-for="role in data.value" :key="role" class="small mb-1">{{role}}</div>
                </template>
            </b-table>

            <b-skeleton-table
                v-else
                :rows="4"
                :columns="4"
                :table-props="{ bordered: true }"
            ></b-skeleton-table>

        </b-card>
        
    </div>
</template>

<script>
import { suppliosApi } from '@/js/api-service';
import isEmpty from 'lodash/isEmpty';

export default {
    name: 'TenantSettingsLicenseCounts',
    components: {},
    props: {
        
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: false,
            initialDataLoaded: false,  // set to true the first time you load data
            countsObj: {},  // put object here from API
            fields: [
                {
                    key: 'name',
                    label: 'License Type',
                    sortable: true,
                    tdClass: 'font-weight-bold',
                    formatter: (value) => {
                        if (value === 'Sourcing User') {
                            return 'Full User';
                        } else {
                            return value;
                        }
                    }
                },
                {
                    key: 'roles',
                    label: 'Included Roles',
                    sortable: false,
                },
                {
                    key: 'count',
                    label: 'Currently Used',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    key: 'allowed',
                    label: 'Plan Limit',
                    sortable: true,
                    class: 'text-center',
                },
            ]
        }
    },
    computed: {
        countsList: function() {
            // take the object from API and make it a list instead... put the key into the object, then put into list
            if (!this.countsObj || isEmpty(this.countsObj)) return [];
            let list = [];
            for (const [ltype, nested] of Object.entries(this.countsObj)) {
                let ltypeObj = {...nested};
                ltypeObj.value = ltype;
                list.push(ltypeObj);
            }
            return list;
        },
    },
    mounted: function() {
        // this.getCounts();  // don't do anything on mounted, but wait for other table to load and call getCounts() on this via refs?
    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        getCounts: function() {
            this.loading = true;
            return suppliosApi.orgData.licenseTypeCounts()
                .then(response => {
                    this.countsObj = response.data;
                    this.initialDataLoaded = true;
                    return true;
                })
                .catch(error => {
                    this.handleError(error, 'Error while getting license counts');
                    return false;
                })
                .then(status => {
                    this.loading = false;
                    return status;
                })
        },
    }
}
</script>

<style>

</style>